/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AnalysisValue } from './analysisValue';


/**
 * Schema for an analysis object
 */
export interface Analysis { 
    /**
     * Analytic process ID
     */
    processid?: number;
    /**
     * Analytic value ID
     */
    valueid?: number;
    /**
     * Position of the column in the order of table column sorting
     */
    sort?: number;
    /**
     * Title of the column
     */
    columnTitle?: string;
    value?: AnalysisValue;
    /**
     * The alignment of the entry in the table cell
     */
    align?: string;
    /**
     * Number of decimal places for a specific number value field
     */
    decimals?: number;
    /**
     * Data type for the column to be sorted by
     */
    sortType?: string;
    /**
     * Flag for the pre-selected column to be pre-sorted either ascending (1) or descending (-1)
     */
    sortOrder?: number;
}

